export function resolveUploadFile({ selectedFile, videoPreviewUrl, dataURLtoFile }) {
    if (selectedFile) {
        return selectedFile;
    }

    if (videoPreviewUrl && dataURLtoFile) {
        return dataURLtoFile(videoPreviewUrl, "video.mp4");
    }

    return null;
}

export function isBlobPreviewUrl(url) {
    return Boolean(url && String(url).startsWith("blob:"));
}

export function revokeBlobPreviewUrl(url) {
    if (isBlobPreviewUrl(url)) {
        URL.revokeObjectURL(url);
    }
}

export function previewUrlAfterSuccessfulUpload({ videoPreviewUrl, showPreview }) {
    if (!isBlobPreviewUrl(videoPreviewUrl)) {
        return videoPreviewUrl;
    }

    if (showPreview) {
        return videoPreviewUrl;
    }

    URL.revokeObjectURL(videoPreviewUrl);

    return true;
}

export function isIosAccessibleFileInputStyle(styles) {
    return styles.display !== "none";
}
